import {useDispatch, useSelector} from "react-redux";
import {Empty, notification} from "antd";
import {useContext, useEffect, useState} from "react";
import _ from "lodash";
import {
    Button,
    Icon,
    Loading,
    Modal
} from "../../../components";
import {
    hostInfoActions,
    hostInfoErrorSelector,
    hostInfoFilterSelector,
    hostInfoItemsSelector,
    hostInfoLoadingSelector,
    hostInfoPaginationSelector
} from "../HostInfoSlice";
import ActionBar from "../../../layout/ActionBar";
import {useCan} from "../../../hooks";
import {hostInfoApi} from "../../../api";
import {apiError, handleRequest} from "../../../utils";
import {
    HostInfoTable,
    HostInfoFormAdd,
    HostInfoFormEdit,
    HostInfoSearchBar
} from "../components";
import {AppContext} from "../../../context/AppProvider";

function HostInfo()
{
    const {
        socket,
    } = useContext(AppContext);

    const can = {
        add: useCan('hostInfoAdd'),
        edit: useCan('hostInfoEdit'),
        delete: useCan('hostInfoDelete'),
        status: useCan('hostInfoStatus'),
    }

    const dispatch = useDispatch();

    const items = useSelector(hostInfoItemsSelector)

    const loading = useSelector(hostInfoLoadingSelector)

    const error = useSelector(hostInfoErrorSelector)

    const pagination = useSelector(hostInfoPaginationSelector)

    const filter = useSelector(hostInfoFilterSelector)

    const [itemEdit, setItemEdit] = useState({});

    const [loadingDelete, setLoadingDelete] = useState(false);

    //Model
    const [openModal, setOpenModal] = useState({
        add 	 : false,
        edit    : false,
        delete    : false,
    });

    const handleModalOpen = (modal) => {
        openModal[modal] = true;
        setOpenModal({...openModal})
    }

    const handleModalClose = (modal) => {
        openModal[modal] = false;
        setOpenModal({...openModal});
    }

    const eventsHandler = {
        load: () =>
        {
            dispatch(hostInfoActions.fetchData({
                ...filter,
                detail: ['user']
            }))
        },
        search: (newFilter) => {
            dispatch(hostInfoActions.setFilterWithDebounce({
                ...newFilter, detail: ['user']
            }));
        },
        changePagination: (page) =>
        {
            dispatch(hostInfoActions.setFilter({
                ...filter, detail: ['user'], page
            }))
        },
        changeStatus: async (item, status) =>
        {
            if (!item?.id) {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu dịch vụ'});
                return;
            }

            let [error, response] = await handleRequest(hostInfoApi.status({
                status: status,
                id: item.id
            }));

            let message = apiError(`Cập nhật trạng thái yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Cập nhật trạng thái yêu cầu thành công`
                });
                let newItem = JSON.parse(JSON.stringify(item));

                newItem.status = response.data.status;

                dispatch(hostInfoActions.update(newItem));

                socket.emit("set-notification-user", response.data.notification);
            }
        },
        add: async (data) =>
        {
            let [error, response] = await handleRequest(hostInfoApi.add(data));

            let message = apiError(`Thêm yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Thêm yêu cầu thành công`
                });

                dispatch(hostInfoActions.add(response.data.item));

                socket.emit("set-notification-user", response.data.notification);

                handleModalClose('add');
            }
        },
        edit: async (item, data) =>
        {
            if (!item?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu để đăng nhập'});

                return false;
            }

            data.id = item.id;

            let [error, response] = await handleRequest(hostInfoApi.update(data));

            let message = apiError(`Cập nhật yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Cập nhật yêu cầu thành công`
                });
                dispatch(hostInfoActions.update({
                    ...response.data
                }));

                handleModalClose('edit');
            }
        },
        delete: async () =>
        {
            if (!itemEdit?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu để đăng nhập'});

                return false;
            }

            setLoadingDelete(true);

            let [error, response] = await handleRequest(hostInfoApi.delete(itemEdit.id));

            let message = apiError(`Xóa yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Xóa yêu cầu thành công`
                });

                dispatch(hostInfoActions.delete(itemEdit.id));

                handleModalClose('delete');
            }

            setLoadingDelete(false);
        },
        loginHost: async (item) =>
        {
            if (!item?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu để đăng nhập'});

                return false;
            }

            let [error, response] = await handleRequest(hostInfoApi.login(item.id));

            let message = apiError(`Đăng nhập vào host thất bại`, error, response);

            if (!message)
            {
                if (response.data.url)
                {
                    window.open(response.data.url, '_blank'); // mở tab mới
                }
            }

            return false;
        },
        loginDb: async (item) =>
        {
            if (!item?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu để đăng nhập'});

                return false;
            }

            let [error, response] = await handleRequest(hostInfoApi.loginDb(item.id));

            let message = apiError(`Đăng nhập vào host thất bại`, error, response);

            if (!message)
            {
                if (response.data.url)
                {
                    window.open(response.data.url, '_blank'); // mở tab mới
                }
            }

            return false;
        },
        ftpCreated: async (item) =>
        {
            if (!item?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu để đăng nhập'});

                return false;
            }

            let [error, response] = await handleRequest(hostInfoApi.ftpCreated(item.id));

            let message = apiError(`Tạo tài khoản ftp thất bại`, error, response);

            if (!message)
            {
                dispatch(hostInfoActions.update({
                    ...item,
                    ftpName: response.data.user,
                }));

                return response.data;
            }

            return {};
        }
    }

    useEffect(() => {
        eventsHandler.load()
    }, [filter])

    if(error)
    {
        notification.error({
            message: 'Có lỗi xảy ra',
            description: error,
        })
    }

    return (
        <>
            <ActionBar title={'Thông Tin Host'}>
                {can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {handleModalOpen('add')}}>Thêm mới</Button>}
                <Button outline small onClick={eventsHandler.load} style={{fontSize:'20px'}}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content">
                    {loading && <Loading />}
                    <HostInfoSearchBar filter={filter} onSearchChange={eventsHandler.search} />
                    {!_.isEmpty(items) && <HostInfoTable
                        items={items}
                        can={can}
                        pagination={pagination}
                        onPaginationChange={eventsHandler.changePagination}
                        handleStatus={eventsHandler.changeStatus}
                        onHandleLoginHost={eventsHandler.loginHost}
                        onHandleLoginDb={eventsHandler.loginDb}
                        onHandleFtpCreated={eventsHandler.ftpCreated}
                        openModal={handleModalOpen}
                        setItemEdit={setItemEdit}
                    />}
                    {_.isEmpty(items) && <Empty />}
                </div>
            </div>
            {
                ((can.add && openModal.add)) && <Modal title="Thêm Yêu Cầu" visible={openModal.add} onCancel={() => {handleModalClose('add')}}>
                    <HostInfoFormAdd onHandleSubmit={eventsHandler.add} />
                </Modal>
            }
            {
                ((can.edit && openModal.edit)) && <Modal title="Cập nhật Yêu Cầu" visible={openModal.edit} onCancel={() => {handleModalClose('edit')}}>
                    <HostInfoFormEdit item={itemEdit} onHandleSubmit={eventsHandler.edit} />
                </Modal>
            }
            {
                (can.delete && itemEdit?.id && openModal.delete) && <Modal title="Xóa yêu cầu thông tin host" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
                    <p>Bạn muốn xóa yêu cầu cho tên miền <b>{itemEdit?.domain}</b>?</p>
                    <br />
                    <div className="d-flex justify-content-end gap">
                        <Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
                        <Button loading={loadingDelete} primary leftIcon={Icon.delete} onClick={eventsHandler.delete}> Xóa </Button>
                    </div>
                </Modal>
            }
        </>

    )
}

export default HostInfo;